export enum MessageType {
  BOT = 'bot',
  RECRUITER = 'outgoing',
  USER = 'incoming',
}
